import { Skeleton } from "Components/ui/skeleton";
import { cn } from "lib/utils";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

function ProfitableTime() {
  const { challengeStageInfoLoading } = useSelector(
    (state) => state.ChallengeOverviewReducer
  );

  const getSlotStyle = (day, time) => {
    const slot = activeSlots.find((s) => s.day === day && s.time === time);

    if (!slot || slot.percentage === 0)
      return { style: "bg-primary-foreground" };

    // Calculate opacity based on profit (20% to 100%)
    const opacity = slot.percentage / 100;
    return { style: `bg-primary`, opacity: opacity };
  };

  const timeSlots = [
    "21:00",
    "18:00",
    "15:00",
    "12:00",
    "09:00",
    "06:00",
    "03:00",
    "00:00",
  ];
  const days = ["M", "Tu", "W", "Th", "F", "Sa", "Su"];

  // Define the active slots (you can customize these)
  const { profitableTime, getProfitableTimeLoading } = useSelector(
    (state) => state.ChallengePerformanceReducer
  );

  const [activeSlots, setActiveSlots] = useState([]);
  useEffect(() => {
    if (profitableTime?.result?.length > 0) {
      setActiveSlots(profitableTime?.result);
    }
  }, [profitableTime]);

  return (
    <div className="chart_cont bg-background border-2 border-border-darkNew rounded-lg h-full flex flex-col relative   p-4 justify-between mid:w-[50%] w-full ">
      <div className="flex justify-between border-b-2 border-b-border-darkNew pb-4  mb-4">
        <div className="text-base">Most Profitable Time</div>
        {challengeStageInfoLoading || getProfitableTimeLoading ? (
          <Skeleton className="w-16 h-6 " />
        ) : (
          <div className="text-lg font-N_Bold">
            {profitableTime?.maxProfit?.time || "-"}
          </div>
        )}
      </div>
      {challengeStageInfoLoading || getProfitableTimeLoading ? (
        <Skeleton className="w-full min-h-[250px]  h-full" />
      ) : (
        <div className="grid grid-cols-[auto_repeat(7,1fr)] gap-5">
          {/* Time labels */}
          <div className="flex flex-col gap-4">
            {timeSlots.map((time) => (
              <div
                key={time}
                className="h-5 flex items-center justify-end pr-2 text-xs text-white opacity-30"
              >
                {time}
              </div>
            ))}
          </div>

          {/* Days and slots */}
          {days.map((day) => (
            <div key={day} className="gap-4 flex flex-col-reverse">
              {/* Day label */}
              <div className="h-5 sm:w-auto w-2 flex items-center justify-center text-xs text-white opacity-30">
                {day}
              </div>
              <div className="flex flex-col gap-4">
                {timeSlots.map((time, index) => (
                  <div
                    key={`${day}-${time}`}
                    className={cn(
                      "h-5 rounded-md",
                      getSlotStyle(day, time)?.style
                    )}
                    style={{
                      opacity: getSlotStyle(day, time)?.opacity,
                    }}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ProfitableTime;
